<template>
    <div>
        <vx-card class="mb-4">
            <div class="breadcrumbs flex">
                <feather-icon icon="UserIcon" svgClasses="w-6 h-6 mr-3"/>
                <h4 v-if="userName" class="mr-3 font-bold">{{ userName }}</h4>
                <a class="cursor-pointer ml-6"
                   @click="$router.push({path: '/admin/members/referrals', query: {uuid: userUuid}}).catch(() => {})">
                    View user's referrals tree</a>
            </div>
        </vx-card>
        <user-data v-if="userUuid" :userUuid="userUuid"></user-data>

        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <div class="vx-card">
                    <div class="vx-card__header">
                        <div class="vx-card__title">
                            <h4 class="mb-4">Referrals</h4>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col mb-base">
                            <vs-input id="search-box-refs" v-on:input="filterChangedRefs" icon="search" size="large"
                                      v-model="searchInputRefs"
                                      label-placeholder="Search"
                                      class="ml-6 mt-6"/>
                        </div>
                        <div class="vx-col mb-base grid-filter-icon-wrapper"
                             v-on:click="showFiltersRefs = !showFiltersRefs">
                            <feather-icon icon="FilterIcon" svgClasses="w-6 h-6 mt-6"/>
                        </div>
                    </div>

                    <div v-if="listOfReferrers && listOfReferrers.length > 0" class="vx-row ml-6" v-bind:class="{'mb-base': showFiltersRefs}">
                        <vs-checkbox class="mr-6" v-on:change="setActiveStatus('active', $event)"
                                     v-model="showMembActive">
                            Active membership
                        </vs-checkbox>
                        <vs-checkbox v-on:change="setActiveStatus('not-active', $event)" v-model="showMembInactive">
                            Inactive membership
                        </vs-checkbox>
                    </div>

                    <div class="vx-row ag-grid-columns-filter-wrapper" v-bind:class="{ show: showFiltersRefs}">
                        <div class="vx-col ml-6">
                            <span v-for="(column, index) in columnsFilterRefs" v-bind:key="index"
                                  class="filter-checkbox-wrapper mb-2">
                                <vs-checkbox v-model="column.show"
                                             @change="setColumnsVisibilityRefs()">{{ column.name }}</vs-checkbox>
                            </span>
                        </div>
                    </div>
                    <ag-grid-vue
                        class="ag-theme-material w-100 my-4 ag-grid-table clickable-grid"
                        :columnDefs="referrersListColumns"
                        :rowData="refereesData"
                        :defaultColDef="defaultColDef"
                        :gridOptions="gridOptionsRefs"
                        :components="referrerComponents"
                        rowSelection="single"
                        @rowClicked="onReferrerRowSelected"
                        colResizeDefault="shift"
                        :animateRows="true"
                        :pagination="true"
                        :paginationPageSize="paginationPageSize"
                        :suppressPaginationPanel="true"
                        overlayNoRowsTemplate=" "
                        :isExternalFilterPresent="isExternalFilterPresent"
                        :doesExternalFilterPass="doesExternalFilterPass"
                        @gridReady="setGridSizeRefs($event)">
                    </ag-grid-vue>
                    <vs-pagination
                        :total="totalPages"
                        :max="paginationMaxSize"
                        v-model="currentPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RestService from '../services/RestService';
import {AgGridVue} from 'ag-grid-vue';
import '../assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererDate from './cell-renderer/CellRendererDate';
import CellRendererValue from './cell-renderer/CellRendererValue';
import CellRendererMembership from './cell-renderer/CellRendererMembership';
import CellRendererAvatar from './cell-renderer/CellRendererAvatar';
import UserData from "../layouts/components/UserData";

export default {
    name: "members-referrals-admin-list",
    components: {
        UserData,
        AgGridVue,
        CellRendererDate,
        CellRendererValue,
        CellRendererMembership,
        CellRendererAvatar
    },
    watch: {
        async $route() {
            await this.checkAvailableUserData();
        },
    },
    async beforeMount() {
        if (!this.userUuid) {
            this.userUuid = this.$route.query.uuid;
        }

        if (!this.userUuid) {
            await this.$router.push({name: 'admin-view'});
        }

        const usersResponse = await RestService.getAllUsers();
        if (usersResponse.success) {
            this.usersList = usersResponse.data;
        }

        if (!this.listOfReferrers && this.userUuid) {
            await this.getUsersReferrals();
        }

        await this.checkAvailableUserData();
    },
    methods: {
        async checkAvailableUserData() {
            this.userUuid = this.$route.query.uuid;

            if (!this.userName && this.userUuid) {
                let user = this.usersList.find((el) => {
                    return el.uuid === this.userUuid;
                });
                this.userName = user.first_name + ' ' + user.last_name;
            }
        },
        setGridSizeRefs(params) {
            if (window.innerWidth > 1024)
                params.api.sizeColumnsToFit();
            this.gridOptionsRefs.api.setDomLayout('autoHeight');
        },

        async onReferrerRowSelected(event) {
            await this.$router.push({path: '/admin/members/referrals', query: {uuid: event.node.data.uuid}});
        },

        async getUsersReferrals() {
            const referrersResponse = await RestService.getUsersReferrals(this.userUuid);
            if (referrersResponse.success)
                this.listOfReferrers = referrersResponse.data.referrals;
        },

        filterChangedRefs() {
            this.gridApiRefs.setQuickFilter(document.getElementById('search-box-refs').value);
        },

        setColumnsVisibilityRefs() {
            this.columnsFilterRefs.forEach(c => {
                this.gridOptionsRefs.columnApi.setColumnVisible(c.id, c.show);
            });
            // TODO this needs optimization
            if (window.innerWidth > 1024)
                this.gridApiRefs.sizeColumnsToFit();
        },
        setActiveStatus(value, event) {
            if (value === 'active') {
                this.showMembActive = event.target.checked;
            } else {
                this.showMembInactive = event.target.checked;
            }

            if (this.showMembInactive && this.showMembActive) {
                this.activeFilterChanged('all');
            } else if (this.showMembActive && !this.showMembInactive) {
                this.activeFilterChanged('active');
            } else if (!this.showMembActive && this.showMembInactive) {
                this.activeFilterChanged('not-active');
            } else {
                this.activeFilterChanged('null');
            }
        },

        activeFilterChanged(newVal) {
            this.membStatus = newVal;

            if (this.gridApiRefs) {
                this.gridApiRefs.onFilterChanged();
            }
        },

        isExternalFilterPresent() {
            return this.membStatus !== 'all';
        },

        doesExternalFilterPass(node) {
            switch (this.membStatus) {
                case 'active':
                    return node.data.active === true
                case 'not-active':
                    return node.data.active === false
                case 'null':
                    return false;
                default:
                    return true;
            }
        },
    },
    computed: {
        refereesData() {
            return this.listOfReferrers;
        },
        getUsers() {
            return this.usersList;
        },
        paginationPageSize() {
            return 10; // TODO maybe change
        },
        paginationMaxSize() {
            if (this.gridApiRefs) {
                let pagesNr = this.gridApiRefs.paginationGetTotalPages();
                return pagesNr < 8 ? pagesNr + 1 : 7; // TODO maybe change this
            } else
                return 1;
        },
        totalPages() {
            if (this.gridApiRefs)
                return this.gridApiRefs.paginationGetTotalPages();
            else
                return 0;
        },
        currentPage: {
            get() {
                if (this.gridApiRefs)
                    return this.gridApiRefs.paginationGetCurrentPage() + 1;
                else
                    return 1;
            },
            set(val) {
                this.gridApiRefs.paginationGoToPage(val - 1);
            }
        },
        currency() {
            return this.$store.state.currency;
        }
    },
    mounted() {
        this.gridApiRefs = this.gridOptionsRefs.api;
        this.columnsFilterRefs = this.referrersListColumns.map(c => {
            return {id: c.field, name: c.headerName, show: true};
        });
    },
    data() {
        return {
            gridOptionsRefs: {},
            gridApiRefs: null,
            pendingList: null,
            usersList: null,
            usersCount: 0,
            requestsCount: 0,
            currentMoney: 0,
            pendingRequestsNum: 0,
            monthRevenue: 0,
            yearRevenue: 0,
            monthPayout: 0,
            yearPayout: 0,
            pendingPayout: 0,
            pendingRequest: 0,
            userUuid: null,
            userName: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
                width: 300
            },
            columnDefs: null,
            rowData: null,
            referrersListColumns: [
                {
                    headerName: 'User',
                    field: 'uuid',
                    cellRendererFramework: 'CellRendererAvatar',
                    cellClass: 'text-center'
                },
                {
                    headerName: 'First name',
                    field: 'first_name'
                },
                {
                    headerName: 'Last name',
                    field: 'last_name'
                },
                {
                    headerName: 'Downline',
                    field: 'descendants',
                    cellClass: 'text-center'
                },
                {
                    headerName: 'Membership status',
                    field: 'active',
                    cellClass: 'text-center',
                    cellRendererFramework: 'CellRendererMembership',
                }
            ],
            columnsFilterRefs: [],
            showFiltersRefs: false,
            listOfReferrers: null,
            membStatus: 'all',
            showMembActive: true,
            showMembInactive: true,
            searchInputRefs: '',
            referrerComponents: {
                CellRendererAvatar
            }
        }
    }
}
</script>
